var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"item"},[_c('router-link',{attrs:{"to":("/exhibit-detail-" + (item.id)),"target":"_blank"}},[_c('p',[_vm._v(_vm._s(item.title))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }